"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcTimeDifferenceHourPercent = exports.calcTimeDifferenceHHMM = void 0;
const calcTimeDifferenceHHMM = (day1, day2) => {
    const seconds = (day1 - day2) / 1000 / 60;
    const hours = Math.floor(seconds / 60);
    const minutes = Math.ceil(seconds - hours * 60);
    const hourString = hours ? `${(hours <= 9 && hours >= 0) ? "0" : ""}${hours}` : "00";
    const minuteString = minutes ? `${(minutes <= 9 && minutes >= 0) ? "0" : ""}${minutes}` : "00";
    return `${hourString}:${minuteString}`;
};
exports.calcTimeDifferenceHHMM = calcTimeDifferenceHHMM;
const calcTimeDifferenceHourPercent = (day1, day2) => {
    if (!day1 || !day2)
        return 0;
    const seconds = (day1 - day2) / 1000 / 60;
    const hours = (seconds / 60);
    return hours;
};
exports.calcTimeDifferenceHourPercent = calcTimeDifferenceHourPercent;
